export default "__VITE_ASSET__BIh8zark__"